import { boDau } from './boDau';
import { chuanHoaSdt } from './phoneNumber';

// Tim hoi thoai theo DANH TINH khach: ten, SDT, ma hoi thoai. KHONG quet noi
// dung tin nhan — mot tu ngan nhu "tran" trung "tinh trang" trong tin cuoi nen
// ket qua loang, khong con dung de tim nguoi. Quet noi dung la viec cua o Tim
// kiem.
export const khopTimKiem = (hoiThoai, tuKhoa) => {
  // Bo dau ca hai ve: go "tuyen dung" ra "Tuyển Dụng", go "Tuyển" van ra.
  const tu = boDau(tuKhoa).trim().toLowerCase();
  if (!tu) return true;

  // SDT trong DB la E.164, nguoi truc go dau `0`. Doi ca hai ve dang noi dia
  // moi khop; go chua het so thi `chuanHoaSdt` tra rong, dung nguyen tu khoa.
  const tuSdt = chuanHoaSdt(tuKhoa) || tu;
  const ten = hoiThoai?.meta?.sender?.name || '';
  const sdt = chuanHoaSdt(hoiThoai?.meta?.sender?.phone_number || '');

  return (
    boDau(ten).toLowerCase().includes(tu) ||
    String(hoiThoai?.id ?? '').includes(tu) ||
    (Boolean(sdt) && sdt.includes(tuSdt))
  );
};

export default khopTimKiem;
